var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolley(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#916EF4;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    className: "st0",
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74,63.5c-1.1,0-2-0.4-2.8-1.1c-0.6-0.6-1-1.4-1.3-2.4L65,38.5l4.1,0c0.2,0,0.5,0.1,0.9,0.2 c0.9,0.5,1.6,1.2,2,2.2c0,0.1,1.2,5.6,3.6,16.5c0.2,0.6,0.5,0.9,0.8,0.9c0.5,0,1.2-0.7,2-2.2c1.2-2.3,2.2-5.3,3-9 c0.3-1.7,0.5-3.2,0.5-4.6c0-2.1-0.5-3.5-1.6-4.1c-0.3-0.2-0.7-0.3-1.1-0.3c-0.5,0-1,0.1-1.6,0.4h0.3c0.7,0,1.4,0.3,2,0.8 c0.6,0.6,0.9,1.3,0.9,2.1c0,0.6-0.2,1.2-0.6,1.8c-0.6,0.7-1.4,1.1-2.3,1.1c-1,0-1.8-0.4-2.4-1.3c-0.3-0.5-0.5-1.1-0.5-1.8 c0-1.3,0.4-2.5,1.4-3.4c1-1,2.2-1.5,3.6-1.5c1.2,0,2.3,0.4,3.2,1.3c1.3,1.2,1.9,3.3,1.9,6.1c0,2.5-0.5,5.3-1.4,8.4 c-1.3,4.1-3,7.2-5.1,9.3c-1.3,1.3-2.6,1.9-3.8,1.9H74z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolley);
export default __webpack_public_path__ + "static/media/Volley.d58f59c534044c83ccbecee26865e2cf.svg";
export { ForwardRef as ReactComponent };